import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-button-toggle-group',
  templateUrl: './button-toggle-group.component.html',
  styleUrl: './button-toggle-group.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ButtonToggleGroupComponent implements OnInit, OnDestroy {
  @Input() values: any[] = [];
  @Input() control!: FormControl<string | null>;
  @Input() bindValue: string = 'value';
  @Input() bindLabel: string = 'label';
  @Input() label: string = '';
  @Input() isRequired: boolean = false;
  @Input() isTranslate: boolean = true;
  @Input() isError: boolean = false;
  @Output() onValueChange = new EventEmitter();

  private valueChangesSub?: Subscription;

  ngOnInit(): void {
    this.valueChangesSub = this.control.valueChanges.subscribe((value) => {
      this.onValueChange.emit(value);
    });
  }

  ngOnDestroy(): void {
    this.valueChangesSub?.unsubscribe();
  }

  protected onToggleClick(value: string): void {
    const current = this.control.value;
    const newValue = current === value && !this.isRequired ? null : value;
    this.control.setValue(newValue);
  }
}
